export default "__VITE_ASSET__CnRjT$JK__"